import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './UpgradeSubscriptionModal.css';

const UpgradeSubscriptionModal = ({ isOpen, onClose, onSubmit }) => {
  const { t, i18n } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);
    setError('');

    try {
      await onSubmit();
      onClose();
    } catch (err) {
      setError(err.message || t('upgradeSubscriptionModal.errors.submitFailed'));
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setError('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="upgrade-subscription-modal-overlay" onClick={handleClose}>
      <div className="upgrade-subscription-modal" onClick={(e) => e.stopPropagation()} dir={i18n.dir()}>
        <div className="upgrade-subscription-modal-content">
          <h2 className="upgrade-subscription-modal-title">
            {t('upgradeSubscriptionModal.title')}
          </h2>
          <p className="upgrade-subscription-modal-message">
            {t('upgradeSubscriptionModal.message')}
          </p>

          {error && (
            <div className="upgrade-subscription-modal-error-container">
              <span className="upgrade-subscription-modal-error">{error}</span>
            </div>
          )}

          <form onSubmit={handleSubmit} className="upgrade-subscription-modal-form">
            <div className="upgrade-subscription-modal-actions">
              <button
                type="button"
                className="upgrade-subscription-modal-btn upgrade-subscription-modal-btn-cancel"
                onClick={handleClose}
                disabled={isSubmitting}
              >
                {t('upgradeSubscriptionModal.buttons.cancel')}
              </button>
              <button
                type="submit"
                className="upgrade-subscription-modal-btn upgrade-subscription-modal-btn-submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? t('upgradeSubscriptionModal.buttons.submitting') : t('upgradeSubscriptionModal.buttons.interested')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpgradeSubscriptionModal;

